import type { TranslateDictionary } from './en.js';

export const El: TranslateDictionary = {
  'Start airplay': 'Έναρξη AirPlay',
  'Stop airplay': 'Διακοπή AirPlay',
  Audio: 'Ήχος',
  Captions: 'Υπότιτλοι',
  'Enable captions': 'Ενεργοποίηση υπότιτλων',
  'Disable captions': 'Απενεργοποίηση υπότιτλων',
  'Start casting': 'Έναρξη μετάδοσης',
  'Stop casting': 'Διακοπή μετάδοσης',
  'Casting to {device}': 'Μετάδοση σε {device}',
  'Enter fullscreen mode': 'Πλήρης οθόνη',
  'Exit fullscreen mode': 'Έξοδος πλήρους οθόνης',
  Mute: 'Σίγαση',
  Unmute: 'Επαναφορά ήχου',
  'Enter picture in picture mode': 'Ενεργοποίηση λειτουργίας εικόνα-σε-εικόνα',
  'Exit picture in picture mode': 'Απενεργοποίηση λειτουργίας εικόνα-σε-εικόνα',
  Play: 'Αναπαραγωγή',
  Pause: 'Παύση',
  'Playback rate': 'Ταχύτητα αναπαραγωγής',
  'Playback rate {playbackRate}': 'Ταχύτητα αναπαραγωγής {playbackRate}',
  Quality: 'Ποιότητα',
  'Seek backward': 'Πίσω',
  'Seek forward': 'Μπροστά',
  Settings: 'Ρυθμίσεις',
  Auto: 'Αυτόματο',
  'audio player': 'αναπαραγωγέας ήχου',
  'video player': 'αναπαραγωγέας βίντεο',
  volume: 'Ένταση',
  seek: 'Αναζήτηση',
  'closed captions': 'Υπότιτλοι',
  'current playback rate': 'τρέχουσα ταχύτητα αναπαραγωγής',
  'playback time': 'χρόνος αναπαραγωγής',
  'media loading': 'φόρτωση πολυμέσων',
  settings: 'Ρυθμίσεις',
  'audio tracks': 'κομμάτια ήχου',
  quality: 'Ποιότητα',
  play: 'αναπαραγωγή',
  pause: 'παύση',
  mute: 'σίγαση',
  unmute: 'επαναφορά ήχου',
  'chapter: {chapterName}': 'κεφάλαιο: {chapterName}',
  live: 'ζωντανά',
  Off: 'Απενεργοποιημένο',
  'start airplay': 'έναρξη AirPlay',
  'stop airplay': 'διακοπή AirPlay',
  'start casting': 'έναρξη μετάδοσης',
  'stop casting': 'διακοπή μετάδοσης',
  'enter fullscreen mode': 'πλήρης οθόνη',
  'exit fullscreen mode': 'έξοδος πλήρους οθόνης',
  'enter picture in picture mode': 'ενεργοποίηση λειτουργίας εικόνα-σε-εικόνα',
  'exit picture in picture mode': 'απενεργοποίηση λειτουργίας εικόνα-σε-εικόνα',
  'seek to live': 'μετάβαση σε ζωντανή μετάδοση',
  'playing live': 'αναπαραγωγή ζωντανά',
  'seek back {seekOffset} seconds': 'πίσω {seekOffset} δευτερόλεπτα',
  'seek forward {seekOffset} seconds': 'μπροστά {seekOffset} δευτερόλεπτα',
  'Network Error': 'Σφάλμα δικτύου',
  'Decode Error': 'Σφάλμα αποκωδικοποίησης',
  'Source Not Supported': 'Η πηγή δεν υποστηρίζεται',
  'Encryption Error': 'Σφάλμα κρυπτογράφησης',
  'A network error caused the media download to fail.':
    'Ένα σφάλμα δικτύου προκάλεσε αποτυχία λήψης του πολυμέσου.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Ένα σφάλμα πολυμέσου προκάλεσε τερματισμό της αναπαραγωγής. Το πολυμέσο μπορεί να είναι κατεστραμμένο ή το πρόγραμμα περιήγησής σας δεν υποστηρίζει αυτή τη μορφή.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Προέκυψε μη υποστηριζόμενο σφάλμα. Ο διακομιστής ή το δίκτυο απέτυχε, ή το πρόγραμμα περιήγησής σας δεν υποστηρίζει αυτή τη μορφή.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Το πολυμέσο είναι κρυπτογραφημένο και δεν υπάρχουν κλειδιά για την αποκρυπτογράφησή του.',
};
